import * as Types from '../api';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type StructureConfigQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type StructureConfigQuery = { __typename?: 'Query', structureConfig: { __typename?: 'StructureConfig', outgoingCallBarrings: Array<Types.OutgoingCallBarring>, sipProxy: string, chattoUrl: string, languages: Array<string>, features: { __typename?: 'Features', alias: Types.FeatureState, auditLog: Types.FeatureState, maliciousCallTrace: Types.FeatureState, callOriginationTerminationDenied: Types.FeatureState, callCenterStatistics: Types.FeatureState, emergencyPrefix: Types.FeatureState, hotNumber: Types.FeatureState, domainBaseColor: Types.FeatureState, domainLogo: Types.FeatureState, domainLoginImage: Types.FeatureState, domainBackgroundImage: Types.FeatureState, editableServiceCodes: Types.FeatureState, enableCarrierAccessCodes: Types.FeatureState, residentialDomains: Types.FeatureState, domainServiceCodeSetting: Types.FeatureState, phoneClient: Types.FeatureState }, services: { __typename?: 'Services', ldap: boolean, callControl: boolean, voicemail: boolean, fax: boolean } } };

export type TranslationsQueryVariables = Types.Exact<{
  locale: Types.Scalars['String']['input'];
}>;


export type TranslationsQuery = { __typename?: 'Query', translations?: string | null };

export type DomainThemeFragmentFragment = { __typename?: 'DomainTheme', color?: string | null, background?: string | null, backgroundColor?: string | null, backgroundIsCentered?: boolean | null, logo?: string | null };

export type DomainThemeQueryVariables = Types.Exact<{
  domainId: Types.Scalars['Int']['input'];
}>;


export type DomainThemeQuery = { __typename?: 'Query', domainTheme?: { __typename?: 'DomainTheme', color?: string | null, background?: string | null, backgroundColor?: string | null, backgroundIsCentered?: boolean | null, logo?: string | null } | null };

export type UserThemeQueryVariables = Types.Exact<{
  userId: Types.Scalars['Int']['input'];
}>;


export type UserThemeQuery = { __typename?: 'Query', userTheme?: { __typename?: 'DomainTheme', color?: string | null, background?: string | null, backgroundColor?: string | null, backgroundIsCentered?: boolean | null, logo?: string | null } | null };

export type UserRolesQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type UserRolesQuery = { __typename?: 'Query', userRoles: Array<{ __typename?: 'Role', name: string, permissions: Array<string>, contexts: Array<{ __typename?: 'Context', id: number, name: string, data: any }> }> };

export const DomainThemeFragmentFragmentDoc = gql`
    fragment DomainThemeFragment on DomainTheme {
  color
  background
  backgroundColor
  backgroundIsCentered
  logo
}
    `;
export const StructureConfigDocument = gql`
    query StructureConfig {
  structureConfig {
    features {
      alias
      auditLog
      maliciousCallTrace
      callOriginationTerminationDenied
      callCenterStatistics
      emergencyPrefix
      hotNumber
      domainBaseColor
      domainLogo
      domainLoginImage
      domainBackgroundImage
      editableServiceCodes
      enableCarrierAccessCodes
      residentialDomains
      domainServiceCodeSetting
      phoneClient
    }
    services {
      ldap
      callControl
      voicemail
      fax
    }
    outgoingCallBarrings
    sipProxy
    chattoUrl
    languages
  }
}
    `;

/**
 * __useStructureConfigQuery__
 *
 * To run a query within a React component, call `useStructureConfigQuery` and pass it any options that fit your needs.
 * When your component renders, `useStructureConfigQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useStructureConfigQuery({
 *   variables: {
 *   },
 * });
 */
export function useStructureConfigQuery(baseOptions?: Apollo.QueryHookOptions<StructureConfigQuery, StructureConfigQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<StructureConfigQuery, StructureConfigQueryVariables>(StructureConfigDocument, options);
      }
export function useStructureConfigLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<StructureConfigQuery, StructureConfigQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<StructureConfigQuery, StructureConfigQueryVariables>(StructureConfigDocument, options);
        }
export function useStructureConfigSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<StructureConfigQuery, StructureConfigQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<StructureConfigQuery, StructureConfigQueryVariables>(StructureConfigDocument, options);
        }
export type StructureConfigQueryHookResult = ReturnType<typeof useStructureConfigQuery>;
export type StructureConfigLazyQueryHookResult = ReturnType<typeof useStructureConfigLazyQuery>;
export type StructureConfigSuspenseQueryHookResult = ReturnType<typeof useStructureConfigSuspenseQuery>;
export type StructureConfigQueryResult = Apollo.QueryResult<StructureConfigQuery, StructureConfigQueryVariables>;
export const TranslationsDocument = gql`
    query Translations($locale: String!) {
  translations(locale: $locale)
}
    `;

/**
 * __useTranslationsQuery__
 *
 * To run a query within a React component, call `useTranslationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTranslationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTranslationsQuery({
 *   variables: {
 *      locale: // value for 'locale'
 *   },
 * });
 */
export function useTranslationsQuery(baseOptions: Apollo.QueryHookOptions<TranslationsQuery, TranslationsQueryVariables> & ({ variables: TranslationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TranslationsQuery, TranslationsQueryVariables>(TranslationsDocument, options);
      }
export function useTranslationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TranslationsQuery, TranslationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TranslationsQuery, TranslationsQueryVariables>(TranslationsDocument, options);
        }
export function useTranslationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TranslationsQuery, TranslationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TranslationsQuery, TranslationsQueryVariables>(TranslationsDocument, options);
        }
export type TranslationsQueryHookResult = ReturnType<typeof useTranslationsQuery>;
export type TranslationsLazyQueryHookResult = ReturnType<typeof useTranslationsLazyQuery>;
export type TranslationsSuspenseQueryHookResult = ReturnType<typeof useTranslationsSuspenseQuery>;
export type TranslationsQueryResult = Apollo.QueryResult<TranslationsQuery, TranslationsQueryVariables>;
export const DomainThemeDocument = gql`
    query DomainTheme($domainId: Int!) {
  domainTheme(domainId: $domainId) {
    ...DomainThemeFragment
  }
}
    ${DomainThemeFragmentFragmentDoc}`;

/**
 * __useDomainThemeQuery__
 *
 * To run a query within a React component, call `useDomainThemeQuery` and pass it any options that fit your needs.
 * When your component renders, `useDomainThemeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDomainThemeQuery({
 *   variables: {
 *      domainId: // value for 'domainId'
 *   },
 * });
 */
export function useDomainThemeQuery(baseOptions: Apollo.QueryHookOptions<DomainThemeQuery, DomainThemeQueryVariables> & ({ variables: DomainThemeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DomainThemeQuery, DomainThemeQueryVariables>(DomainThemeDocument, options);
      }
export function useDomainThemeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DomainThemeQuery, DomainThemeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DomainThemeQuery, DomainThemeQueryVariables>(DomainThemeDocument, options);
        }
export function useDomainThemeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DomainThemeQuery, DomainThemeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DomainThemeQuery, DomainThemeQueryVariables>(DomainThemeDocument, options);
        }
export type DomainThemeQueryHookResult = ReturnType<typeof useDomainThemeQuery>;
export type DomainThemeLazyQueryHookResult = ReturnType<typeof useDomainThemeLazyQuery>;
export type DomainThemeSuspenseQueryHookResult = ReturnType<typeof useDomainThemeSuspenseQuery>;
export type DomainThemeQueryResult = Apollo.QueryResult<DomainThemeQuery, DomainThemeQueryVariables>;
export const UserThemeDocument = gql`
    query UserTheme($userId: Int!) {
  userTheme(userId: $userId) {
    ...DomainThemeFragment
  }
}
    ${DomainThemeFragmentFragmentDoc}`;

/**
 * __useUserThemeQuery__
 *
 * To run a query within a React component, call `useUserThemeQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserThemeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserThemeQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserThemeQuery(baseOptions: Apollo.QueryHookOptions<UserThemeQuery, UserThemeQueryVariables> & ({ variables: UserThemeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserThemeQuery, UserThemeQueryVariables>(UserThemeDocument, options);
      }
export function useUserThemeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserThemeQuery, UserThemeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserThemeQuery, UserThemeQueryVariables>(UserThemeDocument, options);
        }
export function useUserThemeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserThemeQuery, UserThemeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserThemeQuery, UserThemeQueryVariables>(UserThemeDocument, options);
        }
export type UserThemeQueryHookResult = ReturnType<typeof useUserThemeQuery>;
export type UserThemeLazyQueryHookResult = ReturnType<typeof useUserThemeLazyQuery>;
export type UserThemeSuspenseQueryHookResult = ReturnType<typeof useUserThemeSuspenseQuery>;
export type UserThemeQueryResult = Apollo.QueryResult<UserThemeQuery, UserThemeQueryVariables>;
export const UserRolesDocument = gql`
    query UserRoles {
  userRoles {
    name
    contexts {
      id
      name
      data
    }
    permissions
  }
}
    `;

/**
 * __useUserRolesQuery__
 *
 * To run a query within a React component, call `useUserRolesQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserRolesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserRolesQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserRolesQuery(baseOptions?: Apollo.QueryHookOptions<UserRolesQuery, UserRolesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserRolesQuery, UserRolesQueryVariables>(UserRolesDocument, options);
      }
export function useUserRolesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserRolesQuery, UserRolesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserRolesQuery, UserRolesQueryVariables>(UserRolesDocument, options);
        }
export function useUserRolesSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserRolesQuery, UserRolesQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserRolesQuery, UserRolesQueryVariables>(UserRolesDocument, options);
        }
export type UserRolesQueryHookResult = ReturnType<typeof useUserRolesQuery>;
export type UserRolesLazyQueryHookResult = ReturnType<typeof useUserRolesLazyQuery>;
export type UserRolesSuspenseQueryHookResult = ReturnType<typeof useUserRolesSuspenseQuery>;
export type UserRolesQueryResult = Apollo.QueryResult<UserRolesQuery, UserRolesQueryVariables>;